import * as React from 'react';
import { DataTable } from 'damco-components';
import { IResponseCostorRevenue } from 'reducers/bookings/models';
import { StatusRow } from 'components/status-row';
import { LoadingAnimation } from 'components/loading';
import { InPageDialog } from 'damco-components';
import { ModalMain } from 'damco-components';
import { DataList } from 'components/select-advanced';
import {
    FinOpsStatusPermission, originDestinationColsNew, setSortForCBLTable
}
    from '../../../views/job-costing/utils/CostAndRevenueHelpers';
import * as validationMessages from 'constants/validationMessages'
import { ITableSelected } from '../../../views/job-costing/utils/models';
import { ItemCategoryCheck } from 'modules/cost-revenue/component/ItemCategoryCheck';
import { getReasonCodes } from 'actions/mdm';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { IStore } from 'reducers/index';
import { connect } from 'react-redux';
import { isFeatureEnabled, mapReasonCodesToOptions } from 'utilities/util';
import { ISortModel } from 'reducers/filters/models';
import { resetSort, setPage, setSort } from 'actions/filters';
import { ISort } from 'views/job-costing/search/models';
import { fetchCBLEditStatus, fetchChargeItemEdit } from 'actions/costRevenue';
import CostColumnsData from 'views/job-costing/utils/CostColumnsData';
import { IFeatureToggleModel } from 'reducers/featureToggle/models';
import { fetchCustomerToggles } from 'actions/customerToggle';
import { FEATURE_TOGGLES } from 'constants/featureToggles';
import { BLOCKED_TYPES } from 'constants/blockedTypes';
interface IBookingsTableProps {
    id: string;
    isDestination: boolean;
    finOpsStatus: string[];
    responseData: IResponseCostorRevenue;
    isLoading: boolean;
    isEditable: boolean;
    tableTitle: string;
    labelAddAction: string;
    validationError?: any;
    type: string;
    readOnly: boolean;
    forceFooterUpdate: boolean;
    cblId: number;
    addAction: (e: any) => void;
    editAction: (e: any) => void;
    retrieveAction?: () => void;
    linkAction: (e: any, target: string) => void;
    fetchData: (target: any, page?: number, pageSize?: number) => void;
    deleteAction: (e: any, reason: string) => void;
    funcId: string;
    isRevButtonHidden?: boolean;
    isNftpBillable: boolean | undefined;
    isNftpRoeEnabled: boolean | undefined;
}
interface IState {
    sorted: any[] | ISort[];
    clearFilters: boolean;
    isFetchinProgress: boolean;
    page: number;
    pageSize: number;
    totalCount: number;
    data: any[];
    validReason: boolean;
    isDelete: boolean;
    actions: any;
    showDialog: boolean;
    showModal: boolean;
    showErrorModal: boolean;
    errorMessage: string;
    refData: any[];
    reasonCodeSelected: string;
    // tslint:disable: no-empty
    getSelectedItems: () => void,
    setSelectedItems: () => void,
    isDifferentFunc: boolean,
    showAmendMentError: boolean
}

interface IMapDispatchToProps {
    getReasonCodes: (category: string) => Promise<void>;
    setSort: (sort: ISortModel) => void;
    setPage: (page: number) => void;
    resetSort: () => void;
    fetchCBLEditStatus: (id: number, chargeItems: number[], type: string) => Promise<void>;
    fetchChargeItemEdit: (chargeItems: number[], type: string) => Promise<void>;
    fetchCustomerToggles: (customerBeCode: string) => Promise<void>;
}
interface IMapStateToProps {
    reasonCodes: any[];
    editChargeItemStatus: any;
    chargeItemData: any[];
    featureToggles: IFeatureToggleModel[];
}

interface IProperties extends IBookingsTableProps, IMapDispatchToProps, IMapStateToProps { }

export class _CostRevTable extends React.Component<IProperties, IState> {
    // public retrieveBtn:any = this.props.retrieveAction?{ isMoreBtn: false, label: 'Retrieve something', action: () => this.props.retrieveAction()}:{};
    public secondaryStates: any[] = [] // [...this.retrieveBtn]
    public editBtn: any = { isMoreBtn: false, label: 'Edit', action: () => this.editFc() }
    public invoiceBtn: any = { isMoreBtn: false, label: 'Issue Invoice', action: () => this.issueFc() }
    public deleteBtn: any = { isMoreBtn: false, label: 'Delete', action: () => this.checkDeletePermission() }
    public myReason = React.createRef<any>();
    public state: IState = {
        data: [],
        validReason: true,
        isDelete: false,
        reasonCodeSelected: '',
        clearFilters: false,
        actions: {
            primaryActionIsMoreBtn: false,
            primaryActionLabel: this.props.labelAddAction,
            primaryAction: () => this.addFc(),
            secondaryActions: this.secondaryStates,
            parentContextualActions: [
                this.deleteBtn,
                this.editBtn
            ]
        },
        showDialog: false,
        showErrorModal: false,
        showModal: false,
        errorMessage: '',
        refData: [],
        // tslint:disable: no-empty
        getSelectedItems: () => { },
        setSelectedItems: () => { },
        isFetchinProgress: false,
        page: 1,
        pageSize: 10,
        totalCount: 0,
        sorted: [],
        isDifferentFunc: false,
        showAmendMentError: false
    }
    public selectTable: any = React.createRef();
    public refTable: any = React.createRef();

    public componentDidMount = () => {
        const category = this.props.isDestination ? 'ISSO' : 'ESSO'
        this.props.getReasonCodes(category)
        if (this.props.responseData && this.props.responseData.data && this.props.responseData.data.length > 0) {
            this.fetchReset()
        }
    }
    public componentDidUpdate = (prevProps: any, prevState: any) => {
        if (prevProps.responseData !== this.props.responseData) {
            this.setState({
                isFetchinProgress: false,
                page: this.props.responseData.page,
                pageSize: this.props.responseData.pageSize,
                totalCount: this.props.responseData.totalCount,
            })
        }
    }

    public render() {
        return (
            <div>
                <InPageDialog
                    showDialog={this.state.showDialog}
                    type={'error'}
                    message={this.state.errorMessage}
                    closeMethod={() => this.setState({ showDialog: false, errorMessage: '' })} />
                <ItemCategoryCheck
                    displayDialog={this.state.showErrorModal}
                    message={this.getEditMsg()}
                    closeDialog={() => this.setState({
                        showErrorModal: false,
                        isDelete: false,
                        isDifferentFunc: false,
                        showAmendMentError: false
                    })} />
                {!this.state.showErrorModal && <ModalMain height={300}
                    modal={this.state.showModal}
                    title={validationMessages.CostAndRevenue.Delete_Charge}
                    hideMethod={() => this.setState({ showModal: false, reasonCodeSelected: '' })}
                    secondaryMethod={() => this.setState({ showModal: false, reasonCodeSelected: '' })}
                    primaryMethod={() => { this.deleteFc() }} btnTitle1={'OK'} btnTitle2={'Cancel'}>
                    {validationMessages.CostAndRevenue.Alert_Page_Delete}
                    {this.getReasonCodes()}
                </ModalMain>}
                <StatusRow title={this.props.tableTitle} id={this.props.id}>
                    {this.props.isLoading && <LoadingAnimation smallLoad={true} />}
                    <div id={this.props.id} className={this.addPermissionCheck() ? '' : 'status-block'} ref={this.refTable}>
                        <DataTable
                            data={this.props.responseData.data}
                            columns={this.getCols()}
                            isEditable={this.props.isEditable}
                            isSelectable={this.props.readOnly ? false : true}
                            selectedOption="multiple"
                            manualPagination={true}
                            isSortable={true}
                            isResizable={true}
                            hasFooter={true}
                            ref={this.selectTable}
                            showColumnOptions={true}
                            linkAction={(state: any) => { this.props.linkAction(state, this.props.type); }}
                            tableName={`BookingTableCostRevenue BookingTable${this.props.type}`}
                            showPagination={this.props.responseData.data.length > 0}
                            pageCount={Math.ceil(this.state.totalCount / this.state.pageSize)}
                            actions={this.props.readOnly || (this.props.isRevButtonHidden && this.props.type === CostColumnsData.TYPES.REVENUE) ? null : this.state.actions}
                            fetchData={(state: any) => { this.tableOrderFetch(state) }}
                            expandable={false}
                        />
                    </div>
                </StatusRow>
            </div>
        );
    }

    public fetchReset = (page: number = 1, pageSize: number = 10) => {
        if (!this.state.clearFilters) {
            const p = this.state.page ? this.state.page : page;
            const pS = this.state.pageSize ? this.state.pageSize : pageSize;
            this.setState({
                page: p,
                pageSize: pS,
                isFetchinProgress: true
            });
            this.props.fetchData(this.props.type, p, pS);
        }
    };

    public tableOrderFetch = (tableData: any) => {
        let shouldFetch = true
        if (tableData && tableData.sorted.length > 0) {
            const selectedCol = tableData.columns.filter((entry: any) => entry.accessor === tableData.sorted[0].id)
            if (selectedCol && selectedCol[0] && selectedCol[0].headerClassName.includes('no-sorting')) {
                shouldFetch = false
            }
        }
        if (this.props.fetchData && shouldFetch) {
            this.props.setPage(tableData.page + 1)
            const samePageRequest = (tableData.page + 1 !== this.state.page || tableData.pageSize !== this.state.pageSize) || tableData.sorted?.length > 0
            if (!this.state.isFetchinProgress && samePageRequest) {
                if (tableData) {
                    this.setState({
                        page: tableData.page + 1,
                        pageSize: tableData.pageSize,
                        isFetchinProgress: true,
                        showDialog: false,
                    }, () => {
                        if (tableData && tableData.sorted && tableData.sorted.length > 0 && tableData.sorted[0].id && tableData.sorted[0]!.id === 'messageDetails') {
                            this.setState({ isFetchinProgress: false });
                            return
                        }
                        if (tableData && tableData.sorted) {
                            this.setState({ sorted: tableData.sorted });
                            setSortForCBLTable(tableData.sorted, this.props.setSort);
                        } else if (this.state.sorted && this.state.sorted.length) {
                            setSortForCBLTable(this.state.sorted, this.props.setSort);
                        }
                        this.props.fetchData(this.props.type, this.state.page, this.state.pageSize);
                    });
                }
            }
        }
    }
    public getReasonCodes = () => <>
        <div className="padding-top-large">
            <DataList
                id="reasonCode"
                label={'Reason Code'}
                value={this.state.reasonCodeSelected}
                onChange={(e: any) => this.setState({ 'reasonCodeSelected': e })}
                hasError={!this.state.validReason}
                error={!this.state.validReason ? 'Field is Required' : ''}
                data={this.props.reasonCodes && mapReasonCodesToOptions(this.props.reasonCodes)} />
        </div>
    </>

    public getEditMsg = () => {
        if (this.state.showAmendMentError) {
            return validationMessages.CostAndRevenue.Error_Amendment_Blocked;
        }
        if (this.state.isDifferentFunc) {
            return this.state.isDelete ? validationMessages.CostAndRevenue.Alert_Charge_locked_delete : validationMessages.CostAndRevenue.Alert_Charge_locked
        }
        return this.state.isDelete ? validationMessages.CostAndRevenue.Alert_Charge_locked_delete : this.props.editChargeItemStatus.message
    }
    public addPermissionCheck = () => {
        const checkCBLEq = location.href.indexOf('equipments') > -1;
        if (location.href.indexOf('cbls') > -1 || !checkCBLEq && FinOpsStatusPermission(this.props.finOpsStatus, null)) {
            return true
        }
        return false
    }
    public componentWillUnmount = () => {
        this.props.resetSort()
    }

    public fullPermissionCheck = (data: any[]) => {
        const checkOpen = FinOpsStatusPermission(this.props.finOpsStatus, data, this.props.type)
        if (checkOpen) {
            return true
        }
        return false
    }
    public getCols = (): any => {
        const enableBlockedType = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_ICP_AUTOMATION, this.props.featureToggles);
        const isMciChargeEnabled = this.props.isDestination
            ? isFeatureEnabled(FEATURE_TOGGLES.IMPORT_MCI_CHARGE_ENABLED, this.props.featureToggles)
            : isFeatureEnabled(FEATURE_TOGGLES.EXPORT_MCI_CHARGE_ENABLED, this.props.featureToggles);
        return originDestinationColsNew(this.props.isDestination, enableBlockedType, this.props.isNftpBillable, this.props.isNftpRoeEnabled, this.props.type, isMciChargeEnabled);
    }
    public addFc = () => {
        this.setState({ showModal: false, showDialog: false, errorMessage: '' })
        this.props.addAction(this.selectTable.current)
    }
    public checkDeletePermission = async () => {
        const data: any = this.selectTable.current.getSelectedItems()
        const allSameFunc = data.every((obj: any) => obj.viewType.toLowerCase() === this.props.funcId)
        if (!allSameFunc) {
            this.setState({ showErrorModal: true, isDelete: true, isDifferentFunc: true })
        }
        else {
            const selectedItemsPayload = data.map((item: any) => {
                return {
                    chargeItemId: item.id,
                    viewType: item.viewType
                }
            })
            await this.props.fetchCBLEditStatus(this.props.cblId, selectedItemsPayload, this.props.type)
            if (this.props.editChargeItemStatus.validateStatus) {
                this.setState({ showModal: true, showErrorModal: false, isDelete: true })
            } else {
                this.setState({ showErrorModal: true, showModal: false, isDelete: true })
            }
        }
    }
    public deleteFc = () => {
        const data: any = this.selectTable.current;
        if (this.state.reasonCodeSelected) {
            this.setState({ validReason: true, showModal: false, showErrorModal: false, showDialog: false, errorMessage: '', isDelete: true })
            this.props.deleteAction(data.getSelectedItems(), this.state.reasonCodeSelected)
            this.clearSelection()
        } else {
            this.setState({ validReason: false })
        }
    }
    public clearSelection = () => {
        const currSelected: ITableSelected = this.selectTable.current as ITableSelected
        for (const sElement of currSelected.getSelectedItems()) {
            currSelected.getData().splice(currSelected.getData().indexOf(sElement), 1)
        }
        currSelected.hideContextRibbon()
        this.setState({ reasonCodeSelected: '' })
    }
    public editFc = async () => {
        const data: any = this.selectTable.current;
        const selectedItems = data.getSelectedItems().map((item: any) => item.id);
        const enableBlockedType = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_ICP_AUTOMATION, this.props.featureToggles);
        const isAmendMentBlocked = data.getSelectedItems().some((obj: any) => obj.blockedType === BLOCKED_TYPES.AMENDMENT);
        const selectedItemsPayload = data.getSelectedItems().map((item: any) => {
            return {
                chargeItemId: item.id,
                viewType: item.viewType
            }
        })
        const allSameFunc = data.getSelectedItems().every((obj: any) => obj.viewType.toLowerCase() === this.props.funcId)
        if (enableBlockedType && isAmendMentBlocked) {
            this.setState({ showErrorModal: true, showModal: false, showAmendMentError: true, isDifferentFunc: false });
        } else if (!allSameFunc) {
            this.setState({ showErrorModal: true, showModal: false, isDifferentFunc: true })
        } else {
            await this.props.fetchCBLEditStatus(this.props.cblId, selectedItemsPayload, this.props.type)
            if (this.props.editChargeItemStatus.validateStatus) {
                this.setState({ showModal: false, showDialog: false, errorMessage: '' })
                await this.props.fetchChargeItemEdit(selectedItems, this.props.type)
                this.props.editAction([...this.props.chargeItemData])
            } else {
                this.setState({ showErrorModal: true, showModal: false })
            }
        }
    }
    public issueFc = () => {
        this.setState({
            showErrorModal: true
        })
    }
};
const mapStateToProps = (state: IStore): IMapStateToProps => ({
    reasonCodes: state.mdm.reasonCodes,
    editChargeItemStatus: state.newCostRevenue.editChargeItemStatus,
    chargeItemData: state.newCostRevenue.chargeItemData,
    featureToggles: state.featureToggle.featureToggles,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>): IMapDispatchToProps => ({
    getReasonCodes: (category: string) => dispatch(getReasonCodes(category)),
    fetchCustomerToggles: (customerBeCode: string) => dispatch(fetchCustomerToggles(customerBeCode)),
    setSort: (sort: ISortModel) => dispatch(setSort(sort)),
    resetSort: () => dispatch(resetSort()),
    setPage: (page: number) => dispatch(setPage(page)),
    fetchCBLEditStatus: (id: number, chargeItems: number[], type: string) => dispatch(fetchCBLEditStatus(id, chargeItems, type)),
    fetchChargeItemEdit: (chargeItems: number[], type: string) => dispatch(fetchChargeItemEdit(chargeItems, type)),
});
const CostRevTableNew = connect<IMapStateToProps, IMapDispatchToProps, {}, IStore>(mapStateToProps, mapDispatchToProps)(_CostRevTable);

export default CostRevTableNew;
